import axios from 'axios';
import { useCallback } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import fileDownload from 'js-file-download';
import { EXPORT_BOS_API_REQUEST_URL } from '../../../../common/apiConfig';
import {
  MANAGE_OUTS_EXPORT_HISTORY_TRACK_FILE_BEGIN,
  MANAGE_OUTS_EXPORT_HISTORY_TRACK_FILE_SUCCESS,
  MANAGE_OUTS_EXPORT_HISTORY_TRACK_FILE_FAILURE,
  MANAGE_OUTS_EXPORT_HISTORY_TRACK_FILE_DISMISS_ERROR,
} from './constants';

export function exportHistoryTrack(payload = {}) {
  return (dispatch, getState) => {
    dispatch({ type: MANAGE_OUTS_EXPORT_HISTORY_TRACK_FILE_BEGIN });

    const promise = new Promise((resolve, reject) => {
      const token = `Bearer ${getState().home.auth.cognitoIdToken}`;
      const req = axios({
        url: `${EXPORT_BOS_API_REQUEST_URL}/manageOutsHistoryTrack/export`,
        method: 'post',
        data: payload,
        responseType: 'blob',
        headers: { Authorization: token },
      });

      req.then(
        (res) => {
          dispatch({ type: MANAGE_OUTS_EXPORT_HISTORY_TRACK_FILE_SUCCESS, data: res.data });
          // download file (filename optional if backend sets header)
          fileDownload(res.data, 'ManageOutsAudit_Logs.xlsx');
          resolve(res);
        },
        (err) => {
          const message = err && err.response ? (err.response.data && err.response.data.message) || err.response.statusText : 'Export failed';
          dispatch({ type: MANAGE_OUTS_EXPORT_HISTORY_TRACK_FILE_FAILURE, data: { error: message } });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissExportHistoryTrackError() {
  return { type: MANAGE_OUTS_EXPORT_HISTORY_TRACK_FILE_DISMISS_ERROR };
}

export function useExportManageOutsHistoryTrack() {
  const dispatch = useDispatch();
  const { exportHistoryTrackPending, exportHistoryTrackError } = useSelector(
    state => ({
      exportHistoryTrackPending: state.manageOutsAuditTrail.exportHistoryTrackPending,
      exportHistoryTrackError: state.manageOutsAuditTrail.exportHistoryTrackError,
    }),
    shallowEqual,
  );

  const boundAction = useCallback((...args) => dispatch(exportHistoryTrack(...args)), [dispatch]);
  const boundDismiss = useCallback(() => dispatch(dismissExportHistoryTrackError()), [dispatch]);

  return {
    exportHistoryTrack: boundAction,
    exportHistoryTrackPending,
    exportHistoryTrackError,
    dismissExportHistoryTrackError: boundDismiss,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case MANAGE_OUTS_EXPORT_HISTORY_TRACK_FILE_BEGIN:
      return { ...state, exportHistoryTrackPending: true, exportHistoryTrackError: null };
    case MANAGE_OUTS_EXPORT_HISTORY_TRACK_FILE_SUCCESS:
      return { ...state, exportHistoryTrackPending: false, exportHistoryTrackError: null };
    case MANAGE_OUTS_EXPORT_HISTORY_TRACK_FILE_FAILURE:
      return { ...state, exportHistoryTrackPending: false, exportHistoryTrackError: action.data.error };
    case MANAGE_OUTS_EXPORT_HISTORY_TRACK_FILE_DISMISS_ERROR:
      return { ...state, exportHistoryTrackError: null };
    default:
      return state;
  }
}

